import { makeVar } from "@apollo/client";
import auth from "../../utils/auth";

const isLoggedInVar = makeVar(!!auth.getAccessToken());

export default isLoggedInVar;
